export const getContentWithoutHalfLinks = (content: string): string => {
  if (!content) {
    return '';
  }
  const matches = [...content.matchAll(/\*\*/g)];
  if (matches.length % 2 === 1) {
    const lastIndex = content.lastIndexOf('**');
    const unfinishedLink = content.substring(lastIndex);
    const beforeUnfinishedLink = content.substring(0, lastIndex);

    //just started
    if (unfinishedLink.endsWith('**') || unfinishedLink.endsWith('**[')) {
      return beforeUnfinishedLink;
    } else if (unfinishedLink.endsWith('*')) {
      return content + '*';
    } else if (unfinishedLink.includes(')')) {
      return content + '**';
    } else if (unfinishedLink.includes('(')) {
      return content + ')**';
    } else if (unfinishedLink.includes(']')) {
      return content + '()**';
    } else {
      return content + ']()**';
    }
  }
  return content;
};
